import React__default from 'react';
import { SelectAllStatus } from '@keepeek/commons';
import { Typography, Skeleton, Box, CircularProgress } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../DefaultIcon/index.js';
import StyledElementCount, { classes } from './index.styled.js';

var ElementCount = function (_a) {
    var mediasCount = _a.mediasCount, loading = _a.loading, selectStatus = _a.selectStatus, _b = _a.selectLoading, selectLoading = _b === void 0 ? false : _b, _c = _a.onSelect, onSelect = _c === void 0 ? function () { } : _c, className = _a.className, id = _a.id, _d = _a.testId, testId = _d === void 0 ? "ElementCount" : _d, sx = _a.sx, EditableSanitizeHtml = _a.EditableSanitizeHtml, _e = _a.allowSelection, allowSelection = _e === void 0 ? true : _e, _f = _a.KIcon, KIcon = _f === void 0 ? DefaultIcon : _f;
    var t = useTranslation("refront-components").t;
    var check = function () {
        if (!allowSelection) {
            return null;
        }
        if (selectLoading) {
            return React__default.createElement(CircularProgress, { size: 20 });
        }
        switch (selectStatus) {
            case SelectAllStatus.ALL:
                return (React__default.createElement(KIcon, { fontSize: "small", className: clsx(classes.icon, "".concat(classes.icon, "-").concat(selectStatus, " fa-solid fa-square-check fa-lg")), testId: "selectAllButton" }));
            case SelectAllStatus.PARTIAL:
                return (React__default.createElement(KIcon, { fontSize: "small", className: clsx(classes.icon, "".concat(classes.icon, "-").concat(selectStatus, ", fa-solid fa-square-minus fa-lg")), testId: "selectAllButton" }));
            default:
                return (React__default.createElement(KIcon, { fontSize: "small", className: clsx(classes.icon, "".concat(classes.icon, "-").concat(selectStatus, " fa-regular fa-square fa-lg")), testId: "selectAllButton" }));
        }
    };
    return (React__default.createElement(StyledElementCount, { focusRipple: true, onClick: function () {
            allowSelection && onSelect();
        }, className: clsx("ElementCount", className), "data-testid": testId, id: id, sx: sx },
        React__default.createElement(Typography, { className: classes.count, variant: "body1", component: "div" },
            loading && React__default.createElement(Skeleton, { animation: "wave", width: 100 }),
            !loading && mediasCount === 0 && t("components.element-count.label.no-result"),
            !loading && mediasCount > 0 && t("components.element-count.label", { count: mediasCount })),
        allowSelection && (React__default.createElement(Box, { className: classes.selection },
            check(),
            React__default.createElement(Typography, { className: classes.selectionTitle, variant: "caption" },
                EditableSanitizeHtml && (React__default.createElement(EditableSanitizeHtml, { labelKey: "components.element-count.select.label", namespace: "refront-components" })),
                !EditableSanitizeHtml && t("components.element-count.select.label"))))));
};

export { ElementCount as default };
//# sourceMappingURL=index.js.map
